import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { DEFAULT_CLASS_NAME } from './DynamicTiles.constants';
import DynamicTile from './components/DynamicTile';
import { ChildrenPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import './DynamicTiles.less';
var defaultProps = {
  className: '',
  children: []
};
function DynamicTiles(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children;
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_CLASS_NAME, true), _defineProperty(_classNames, className, className), _classNames));
  return /*#__PURE__*/React.createElement(Grid, {
    doubling: true,
    stackable: true,
    className: finalClassName
  }, children);
}
DynamicTiles.defaultProps = defaultProps;
DynamicTiles.Tile = DynamicTile;
export default DynamicTiles;